import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { flatten } from 'lodash';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import usePoolSwapsQuery from '@/composables/queries/usePoolSwapsQuery';
import useUserPoolSwapsQuery from '@/composables/queries/useUserPoolSwapsQuery';
import { Pool } from '@/services/pool/types';

import { PoolTransactionsTab } from '../types';
import Table from './Table.vue';

/**
 * TYPES
 */
type Props = {
  pool: Pool;
  loading: boolean;
  poolActivityType: PoolTransactionsTab;
};

/**
 * PROPS
 */

export default _defineComponent({
  props: {
    pool: { type: null, required: true },
    loading: { type: Boolean, required: true, default: false },
    poolActivityType: { type: null, required: true, default: PoolTransactionsTab.ALL_ACTIVITY }
  } as unknown as undefined,
  setup(__props: {
  pool: Pool;
  loading: boolean;
  poolActivityType: PoolTransactionsTab;
}) {

const props = __props


/**
 * COMPOSABLES
 */
const route = useRoute();

/**
 * STATE
 */

const id = route.params.id as string;
/**
 * QUERIES
 */

const poolSwapsQuery =
  props.poolActivityType === PoolTransactionsTab.ALL_ACTIVITY
    ? usePoolSwapsQuery(id)
    : useUserPoolSwapsQuery(id);

/**
 * COMPUTED
 */
const poolSwaps = computed(() =>
  poolSwapsQuery.data.value
    ? flatten(poolSwapsQuery.data.value.pages.map(page => page.poolSwaps))
    : []
);
const isLoadingPoolSwaps = computed(() => poolSwapsQuery.isLoading.value);
const poolSwapsHasNextPage = computed(() => poolSwapsQuery.hasNextPage?.value);
const poolSwapsIsFetchingNextPage = computed(
  () => poolSwapsQuery.isFetchingNextPage?.value
);

/**
 * METHODS
 */
function loadMorePoolSwaps() {
  poolSwapsQuery.fetchNextPage.value();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Table, {
    tokens: __props.pool ? __props.pool.tokensList : [],
    poolSwaps: _unref(poolSwaps),
    pool: __props.pool,
    isLoading: __props.loading || _unref(isLoadingPoolSwaps),
    isLoadingMore: _unref(poolSwapsIsFetchingNextPage),
    isPaginated: _unref(poolSwapsHasNextPage),
    noResultsLabel: 
      __props.poolActivityType === _unref(PoolTransactionsTab).ALL_ACTIVITY
        ? _ctx.$t('poolTransactions.noResults.allTransactions')
        : _ctx.$t('poolTransactions.noResults.myTransactions')
    ,
    onLoadMore: loadMorePoolSwaps
  }, null, 8, ["tokens", "poolSwaps", "pool", "isLoading", "isLoadingMore", "isPaginated", "noResultsLabel"]))
}
}

})